'use client';

import { SearchDrawer } from '@eliadmin/core/src/components/header/search-bar/search-drawer';
import { AiOutlineSearch } from 'react-icons/ai';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import type { ButtonProps } from '@eliadmin/core/src/components/ui/button';

// Brand-specific trigger only. Dialog, queries, pricing and result rendering live in core.
export type SearchButtonProps = Omit<ButtonProps, 'onClick' | 'className'> & {
  className?: {
    root?: string;
    icon?: string;
  };
  scrolled?: boolean;
  setIsSearchOpen: (open: boolean) => void;
};

export function SearchButton(props: SearchButtonProps) {
  const { className, scrolled, setIsSearchOpen, ...buttonProps } = props;
  return (
    <SearchDrawer
      onOpenChange={setIsSearchOpen}
      trigger={
        <Button
          type="button"
          {...buttonProps}
          variant="none"
          size="none"
          aria-label="Search"
          className={cn(
            'ea-search-button text-black transition-all hover:opacity-80',
            className?.root,
          )}
        >
          <AiOutlineSearch className={cn('ea-search-button__icon h-6 w-6', className?.icon)} />
        </Button>
      }
    />
  );
}
